import * as React from 'react';
import { select } from '@rematch/select';
import connect from 'react-redux/es/connect/connect';
import { Trans } from 'react-i18next';

import { Card } from 'ui';
import { AppLayout } from './AppLayout';
import { TwoColumnsInnerLayout } from './TwoColumnsInnerLayout';
import { Navigation, NavLink } from '../atoms/navigation';

export class Renderer extends React.Component {
  renderSideNavigation() {}
  render() {
    return (
      <AppLayout
        center={
          <React.Fragment>
            <Card shrinked>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Navigation direction="horizontal" id="profile-tabs">
                  <NavLink to="/profile" id="tab-profile-user">
                    <Trans>Your Profile</Trans>
                  </NavLink>
                  <NavLink to="/settings" id="tab-profile-settings">
                    <Trans>Settings</Trans>
                  </NavLink>
                  <NavLink to="/help" id="tab-profile-help">
                    <Trans>Help</Trans>
                  </NavLink>
                  <NavLink to="/invite" id="tab-profile-invite">
                    <Trans>Invite Friends</Trans>
                  </NavLink>
                </Navigation>
              </div>
            </Card>
            <TwoColumnsInnerLayout right={this.props.children} left={this.props.navigation} />
          </React.Fragment>
        }
      />
    );
  }
}

const mapState = (state) => ({
  user: select.session.user(state),
});

export const UserZoneLayout = connect(mapState)(Renderer);
